/**
 * This contains the core code for all effects
 * @module LEANDER
 */
 var LEANDER = (function(module, $) {
	module.cookieBanner = (function() {
		let cookieName = $('.js-cookie-banner').attr('data-cookie'),
			cookieValue = true,
			cookieDuration = 183, //183 days = 6 months
			$cookieBanner,
			$cookieClose;

		/**
		 * The function sets a cookie by adding together the cookie name, value and expiry date
		 * @param {string} cname - cookie name
		 * @param {boolean} cvalue - cookie value
		 * @param {number} exdays - cookie duration
		 */
		const setCookie = function(cname, cvalue, exdays) {
			let expires = '';

			if (exdays) {
				let date = new Date();

				date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
				expires = '; expires=' + date.toUTCString();
			}
			document.cookie =
				cname + '=' + (cvalue || '') + expires + '; path=/';
		};
		/**
		 * A helper function to check whether a cookie is already set.
		 * @param {string} cname - cookie name
		 */
		const isCookieSet = function(cname) {
			return document.cookie.indexOf(cname) >= 0;
		};

		/**
		 * This function makes the cookie banner visible when the user has not already seen it before
		 */
		const displayCookieBanner = function() {
			if ( ! isCookieSet( cookieName )) {
				$cookieBanner.show();
			}
		};
		/**
		 * On click of cookie banner close button the cookie close this slides the cookie banner up to hide it and runs setCookie function
		 */
		const acceptCookie = function() {
			$cookieClose.click(function() {
				$cookieBanner.slideUp();
				setCookie(cookieName, cookieValue, cookieDuration);
			});
		};

		/**
		 * Set cookie variables
		 */
		const setCookieVariables = function() {
			$cookieBanner = $('.js-cookie-banner');
			$cookieClose = $('.js-cookie-banner-close');
		};

		/**
		 * Fires all functions for cookieBanner
		 */
		(function init() {
			setCookieVariables();
			displayCookieBanner();
			acceptCookie();
		})();
	})();

	return module;
})(LEANDER || {}, jQuery);
